import { render } from "./HomeMatches.vue?vue&type=template&id=f9480608"
import script from "./HomeMatches.vue?vue&type=script&lang=js"
export * from "./HomeMatches.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__